import React from 'react'
import { CobuText, CobuStack, CobuHeader, CobuBackButton, CobuAlert } from '@cobu/ui'
import { useNavigate } from 'react-router-dom'
import BlockedUserItem from '../../components/profile/BlockedUserItem'
import { useBlockedUsers } from '../../hooks/useBlockedUsers'
import { Strings } from '../../constants/Strings';

export default function BlockedUsers() {
  const navigate = useNavigate()
  const {
    blockedUserIds,
    isLoading,
    error,
    isUnblocking,
    handleUnblockUser,
    unblockAlertOpen,
    setUnblockAlertOpen,
    userToUnblock,
    confirmUnblockUser,
    cancelUnblockUser,
  } = useBlockedUsers()
  const strings = Strings.get();
  if (isLoading || isUnblocking) {
    return (
      <CobuStack f={1} bg="$backgroundSecondary">
        <CobuHeader title={strings.profile.blockedUsers.title} renderLeft={() => <CobuBackButton onPress={() => navigate(-1)} />} />
        <CobuStack f={1} jc="center" ai="center" bg="$background">
          <CobuText variant="body" color="$cobuDarkBlue" fontSize={'$4' as any} fontWeight="medium">
            {strings.profile.blockedUsers.loadingUsers}
          </CobuText>
        </CobuStack>
      </CobuStack>
    )
  }

  if (error) {
    return (
      <CobuStack f={1} bg="$backgroundSecondary">
        <CobuHeader title={strings.profile.blockedUsers.title} renderLeft={() => <CobuBackButton onPress={() => navigate(-1)} />} />
        <CobuStack f={1} jc="center" ai="center" p="$4" bg="$background" gap="$4">
          <CobuText variant="heading" color="$cobuDarkBlue" ta="center" fontSize={'$4' as any} fontWeight="medium">
            {strings.profile.blockedUsers.unableToLoad}
          </CobuText>
          <CobuText variant="body" color="$cobuDarkBlue50" ta="center" fontSize={'$4' as any} fontWeight="medium">
            {error?.message || 'Unknown error'}
          </CobuText>
          <CobuText variant="body" color="$cobuDarkBlue50" ta="center" fontSize={'$4' as any} fontWeight="medium">
            {strings.profile.blockedUsers.tryAgainLater}
          </CobuText>
        </CobuStack>
      </CobuStack>
    )
  }

  if (blockedUserIds.length === 0) {
    return (
      <CobuStack f={1} bg="$backgroundSecondary">
        <CobuHeader title={strings.profile.blockedUsers.title} renderLeft={() => <CobuBackButton onPress={() => navigate(-1)} />} />
        <CobuStack f={1} jc="center" ai="center" p="$4" bg="$background" gap="$4">
          <CobuText variant="heading" color="$cobuDarkBlue" ta="center" fontSize={'$4' as any} fontWeight="medium">
            {strings.profile.blockedUsers.noBlockedUsers}
          </CobuText>
          <CobuText variant="body" color="$cobuDarkBlue50" ta="center" fontSize={'$4' as any} fontWeight="medium">
            {strings.profile.blockedUsers.noBlockedUsersMessage}
          </CobuText>
        </CobuStack>
      </CobuStack>
    )
  }

  return (
    <CobuStack f={1} bg="$backgroundSecondary">
      <CobuHeader title={strings.profile.blockedUsers.title} renderLeft={() => <CobuBackButton onPress={() => navigate(-1)} />} />
      <CobuStack>
        {blockedUserIds.map((id: string, idx: number) => (
          <BlockedUserItem
            key={`${id}-${idx}`}
            blockedUserId={id}
            onUnblock={handleUnblockUser}
            isFirstItem={idx === 0}
            isLastItem={idx === blockedUserIds.length - 1}
          />
        ))}
      </CobuStack>

      {/* Unblock User Confirmation Alert */}
      <CobuAlert
        open={unblockAlertOpen}
        onOpenChange={setUnblockAlertOpen}
        title={strings.profile.blockedUsers.unblockConfirmationTitle}
        description={strings.profile.blockedUsers.unblockConfirmationMessage}
        acceptText={strings.common.buttonLabels.unblock}
        cancelText={strings.common.buttonLabels.cancel}
        onAccept={confirmUnblockUser}
        onCancel={cancelUnblockUser}
      />
    </CobuStack>
  )
}


